module.exports = __webpack_public_path__ + "assets/img/highlight_background_color.ca0b677.jpeg";


//////////////////
// WEBPACK FOOTER
// ./website/assets/highlight_background_color.jpeg
// module id = MTjC
// module chunks = 50